import React from "react";
import {
  Container,
  Row,
} from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import { Empty, Typography } from "antd";
import ProductCard from "../Comman/ProductCard";

const SearchList = ({ ProductData }) => {
  const { t } = useTranslation();

  if (ProductData?.length === 0) {
    return (
      <div className="grid content-center bg-gray-100 h-[380px]">
        <Empty description={
          <Typography.Text>
            {t('no_data')}
          </Typography.Text>
        }
        />
      </div>
    );
  }

  return (
    <Container>
      <p className={"section-header"}>{t('searchpageh')}</p>
      <p className={"section-p"}>{t('searchpagep')}</p>
      <Row>
        {ProductData.map((product, i) => (
          <ProductCard key={i} product={product} />
        ))}
      </Row>
    </Container>
  );
};

export default SearchList;
